import { Button, Card } from '@design-systems/canvas-ui'
import Icon, { PencilIcon } from '@design-systems/react-icons'
import LifecycleStatusBadge from '../../../shared/brand/components/LifecycleStatusBadge'

const BrandCard = ({ brand, isSetup = false, onEdit, onOpen, setupAction }) => {
  return (
    <Card
      as="article"
      aria-label={`${brand.name} brand details`}
      className="brand-card"
      variant="border"
    >
      {onOpen && !isSetup && (
        <button
          aria-label={`${brand.name} brand details`}
          className="brand-card__open-target"
          onClick={onOpen}
          type="button"
        />
      )}
      <div
        className={`brand-card__header${isSetup ? ' brand-card__header--setup' : ''}`}
      >
        <span className="brand-card__name">{brand.name}</span>
        {!isSetup && (
          <div className="brand-card__header-actions">
            <LifecycleStatusBadge
              className="brand-card__badge"
              fallbackLabel={brand.statusLabel}
              status={brand.lifecycleStatus}
            />
            {onEdit && (
              <Button
                aria-label={`Edit ${brand.name} brand`}
                className="brand-card__edit-button"
                isIconOnly
                onClick={onEdit}
                size="sm"
                variant="ghost-neutral"
              >
                <Icon size="sm" svg={PencilIcon} />
              </Button>
            )}
          </div>
        )}
      </div>

      {isSetup ? (
        <div className="brand-card__setup-action">{setupAction}</div>
      ) : (
        <dl className="brand-card__metadata">
          <div>
            <dt>Steward</dt>
            <dd>{brand.primaryStewardName}</dd>
          </div>
          <div>
            <dt>Last updated</dt>
            <dd>{brand.lastUpdated}</dd>
          </div>
          <div>
            <dt>Ready for Inference</dt>
            <dd>{brand.readByAi ? 'Yes' : 'No'}</dd>
          </div>
        </dl>
      )}
    </Card>
  )
}

export default BrandCard
